var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Pattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "404-pattern",
    xmlns: "http://www.w3.org/2000/svg",
    width: 275.295,
    height: 335.949,
    viewBox: "0 0 275.295 335.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2590"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4289",
    transform: "translate(183.697 244.349)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h.014v30.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4290",
    transform: "translate(244.763 244.351)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.533v61.066H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4291",
    transform: "translate(183.697 213.788)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h61.065v30.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4292",
    transform: "translate(122.634 213.788)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.532v30.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12354",
    d: "m742.682 384.451 30.533 7.984v-38.516.018l-30.533 30.5z",
    transform: "translate(-558.984 -170.695)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12355",
    d: "M806.283 427.535V397H775.75v30.533h.007v.014h15.253l-.007-.014z",
    transform: "translate(-561.521 -244.339)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12356",
    d: "M740.147 427.535V397h-30.534v30.533h.007v.014h15.253l-.007-.014z",
    transform: "translate(-556.448 -244.339)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12357",
    d: "M740.147 491.19v-61.077h-30.534v61.077h.007v.028h15.253l-.007-.028z",
    transform: "translate(-556.448 -308.022)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12358",
    d: "M643.477 397.017v30.533h30.533z",
    transform: "translate(-551.377 -244.354)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12373",
    d: "M674.01 427.55v-30.533h-30.533z",
    transform: "translate(-612.694 -244.354)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12359",
    d: "M674.01 262.109v-30.532h-30.533z",
    transform: "translate(-551.377 73.839)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4293",
    transform: "translate(244.763 122.098)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.533v30.533H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12360",
    d: "M773.216 297.717 742.7 305.7l30.5 30.534h.014z",
    transform: "translate(-558.986 -61.353)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4294",
    transform: "translate(153.166 244.351)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.533v30.533H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4295",
    transform: "translate(153.165 244.307)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.533v.014H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12361",
    d: "M717.619 320.823h-.014l-7.984 30.533h7.984v7.984l30.519-7.984z",
    transform: "translate(-564.434 -107.041)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12362",
    d: "M839.351 557.288v-61.065l-30.533 30.533v30.533z",
    transform: "translate(-564.056 -465.69)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4296",
    transform: "translate(153.166 30.533)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.532v30.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4297",
    transform: "translate(183.698 .001)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.532v30.532H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12363",
    d: "M803.747 526.756v-30.532h-30.532v30.532h-30.532l30.532 30.532z",
    transform: "translate(-558.985 -465.691)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4298",
    transform: "translate(92.101)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h61.065v30.533H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4299",
    transform: "translate(92.101 61.066)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h30.533v30.533H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12364",
    d: "M803.747 493.687v-30.533h-61.065v30.517h30.532v.016z",
    transform: "translate(-558.985 -371.556)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12365",
    d: "M640.941 493.687v-30.533h-30.533v30.517h15.266v.016z",
    transform: "translate(-548.841 -371.556)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12375",
    d: "M640.941 493.687v-30.533h-30.533v30.517h15.266v.016z",
    transform: "translate(-610.408 -371.556)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12376",
    d: "M640.941 493.687v-30.533l-30.533 30.517h15.266z",
    transform: "translate(-579.624 -432.622)",
    style: {
      fill: "#212121"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Pattern);
export default __webpack_public_path__ + "static/media/404-pattern.c0a7b4a580345211c02e4292e38e4ab6.svg";
export { ForwardRef as ReactComponent };